module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjRkZGIiBkPSJNOS44NjIuMDRsMS4xOTggMS42LTcuNDI3IDUuNTYxLTMuMDctNC4zNSAxLjYzNS0xLjE1MyAxLjg4MyAyLjY3eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right_icon.svg
// module id = 635
// module chunks = 0